module.exports = __webpack_public_path__ + "media/images/icons/icon-burger-menu-4e632b552d20d9c252f9e363be9bf46e.svg";